import CircleWarningIcon from '@/images/CircleWarningIcon.svg?react';
import BannerArrowIcon from '@/bundle/shared/components/banner/images/BannerArrowIcon.svg?react';
import { CompletePaymentBlock } from '@/bundle/shared/components/banner/styles';
import { useNavigate } from 'react-router';
import { getMasterAdminBillingPath } from '@/bundle/_MasterAdmin/_BillingPage/path/path';
import { Banner } from '@/components/Banner/Banner';
import { COLORS } from '@/styles/colors';
import { SUBSCRIPTION_GRACE_PERIOD_DAYS } from '@/const/shared';

export const SubscriptionGraceBanner = () => {
  const navigate = useNavigate();

  return (
    <Banner background={COLORS.orange[100]} icon={<CircleWarningIcon />}>
      Your subscription payment has <b>failed</b>. Your account is in{' '}
      <b>{SUBSCRIPTION_GRACE_PERIOD_DAYS}-days grace period</b>. Please
      <CompletePaymentBlock onClick={() => navigate(getMasterAdminBillingPath())}>
        complete your payment
        <BannerArrowIcon />
      </CompletePaymentBlock>
    </Banner>
  );
};
